// extracted by mini-css-extract-plugin
export default {"base":"Privacy_base__fxkif","root":"Privacy_root__NPy2x","content":"Privacy_content__RbUfU","header":"Privacy_header__vLzk-","form":"Privacy_form__vfj+N"};